export default "__VITE_ASSET__5Jkk933d__"